import {Country} from "../../../../region/types/Country";
import {getGtmEcommerceCountry} from "../types/gtm_ecommerce_country_map";

export type IGetGTMEcommerceOfferRegion =
    | {
          country?: Country;
          id: number;
          stats: {
              region_type_district?: {name: string} | null;
              region_type_city?: {name: string} | null;
              region_type_voivodeship?: {name: string} | null;
          } | null;
      }
    | {
          country?: Country;
          id: number;
          voivodeship: string | null;
          city: string | null;
          district: string | null;
      }
    | {
          country?: Country;
          id: number;
      };

export const getGTMEcommerceOfferRegion = (region?: IGetGTMEcommerceOfferRegion) => {
    const regionNormalized = normalizeRegion(region);

    return {
        item_category2: getGtmEcommerceCountry(region?.country),
        ...(regionNormalized?.voivodeship
            ? {
                  item_category3: regionNormalized.voivodeship
              }
            : {}),
        ...(regionNormalized?.city
            ? {
                  item_category4: regionNormalized.city
              }
            : {}),
        ...(regionNormalized?.district
            ? {
                  item_category5: regionNormalized.district
              }
            : {}),
        ...(region?.id
            ? {
                  item_region_id: region.id.toString()
              }
            : {})
    };
};

const normalizeRegion = (
    region?: IGetGTMEcommerceOfferRegion
): {
    voivodeship: string | null;
    city: string | null;
    district: string | null;
} | null => {
    if (region && "stats" in region && (region.stats?.region_type_city || region.stats?.region_type_voivodeship || region.stats?.region_type_district)) {
        return {
            voivodeship: region?.stats.region_type_voivodeship?.name || null,
            city: region.stats.region_type_city?.name || null,
            district: region.stats.region_type_district?.name || null
        };
    }

    if (region && ("voivodeship" in region || "city" in region || "district" in region)) {
        const voivodeship = "voivodeship" in region ? (region.voivodeship as string | undefined) : null;
        const city = "city" in region ? (region.city as string | undefined) : null;
        const district = "district" in region ? (region.district as string | undefined) : null;

        return {
            voivodeship: voivodeship || null,
            city: city || null,
            district: district || null
        };
    }

    return null;
};
